const SEE_ALL = 'see-all'

const TRAILING = 'trailing'

export { SEE_ALL, TRAILING }
